import { ToastType } from '@components/toast';
import { systemManagementKeys } from '@services/systemManagement/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { useSnackbar } from 'notistack';

export const useDeleteSystemMaintenanceEvent = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const client = useClient();
  const mutationFn = (maintenanceEventId: any) => {
    const url = `system-management/system-maintenance-event/${maintenanceEventId}`;
    return client.delete(url);
  };
  const result = useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['alertList'] });
      queryClient.invalidateQueries({ queryKey: systemManagementKeys._search() });
      enqueueSnackbar('Maintenance Event Deletion Successful', {
        variant: ToastType.Success,
      });
    },
  });
  return { ...result, deleteMaintenanceEvent: result.mutate };
};
